import { BREAKPOINTS } from '../constants'
import { defaultPreset } from './default'

const TABLET_MIN = 600

/** Continued exploring — peek on mobile, 2 cols tablet, 4 cols desktop, dots only. */
export const continuedExploringPreset = {
  ...defaultPreset,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  centeredSlides: true,
  spaceBetween: 20,
  slideToClickedSlide: true,
  navigation: {
    enabled: false,
  },
  breakpoints: {
    [TABLET_MIN]: {
      slidesPerView: 2,
      slidesPerGroup: 1,
      centeredSlides: false,
      spaceBetween: 16,
    },
    [BREAKPOINTS.XL]: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      centeredSlides: false,
      spaceBetween: 40,
    },
  },
}
